import { useEffect, useState, useCallback } from "react";
import {
  FaChevronRight,
  FaSignOutAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
// Icons from Menu.jsx
import {  AiOutlineHome } from "react-icons/ai";
import { BiHomeAlt, BiStopCircle } from "react-icons/bi";
import { BsHeadset, BsTruck } from "react-icons/bs";
import { LuGroup } from "react-icons/lu";
import { CgTrack } from "react-icons/cg";
import { IoPersonCircleOutline } from "react-icons/io5";
import {
  MdOutlineControlPointDuplicate,
  MdOutlineKeyboardBackspace,
} from "react-icons/md";
import { PiDesktop } from "react-icons/pi";
import { TbReportAnalytics } from "react-icons/tb";
import mlogo from "../assets/m-logo.png";
import movyx from "../assets/MovyxSafe.png";
import { storageKeys } from "../Constants/storage.key";
import menuRoutes from "../Constants/menuRoutes";
import UserNav from "../Pages/Components/NavBar/UserNav";
import { menusService } from "../Services/menus.service";
import { usersService } from "../Services/users.service";
import { storage } from "../Services/storage.service";
import { useTranslation } from "react-i18next";

const Sidebar = () => {
  const { t } = useTranslation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [activeItem, setActiveItem] = useState("home");
  const [activeItemSubMenu, setActiveItemSubMenu] = useState("home");
  const [expandedItems, setExpandedItems] = useState({});
  const [menuLayout, setMenuLayout] = useState([]);
  const [userSession] = useState(storage.get(storageKeys.settings));
  const [showProfile, setShowProfile] = useState(false);
  const [currentAvatarPreview, setCurrentAvatarPreview] = useState(null);

  // Auto-collapse sidebar between 769px and 1080px
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 769 && width <= 1080) {
        setIsCollapsed(true);
      } else if (width > 1080) {
        setIsCollapsed(false);
      }
    };

    handleResize(); // Check on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const loadSavedAvatar = useCallback(async () => {
    try {
      const blob = await usersService.fetchAvatarImage();
      if (blob) {
        const imageUrl = URL.createObjectURL(blob);
        setCurrentAvatarPreview(imageUrl);
      }
    } catch (e) {
      console.error("Erro ao carregar avatar no sidebar:", e);
    }
  }, []);

  useEffect(() => {
    const initialize = async () => {
      try {
        const response = await menusService.menus();

        if (response.length > 0) {
          let menus = response;

          menus = menus.filter((endpointMenu) =>
            menuRoutes.some(
              (localMenu) =>
                localMenu.menuId === endpointMenu.menuId && 
                localMenu.active === true
            )
          );

          const groupedMenus = {};

          // Separando menus de nível 1 e agrupando os submenus
          let parentIndex = -1;
          menus.forEach((item) => {
            if (item.level === 1) {
              parentIndex++;
              groupedMenus[parentIndex] = { ...item, children: [] };
            } else if (item.level === 2) {
              const parent = Object.keys(groupedMenus).find(
                (key) => key == parentIndex
              );
              if (parent) groupedMenus[parent].children.push(item);
            }
          });

          // Remove parent menus that have no children
          const menusWithChildren = Object.values(groupedMenus).filter(menu => 
            menu.children.length > 0
          );

          setMenuLayout(menusWithChildren);
        } else {
          throw new Error("Erro ao carregar menus");
        }
      } catch (err) {
        console.log(err);
      }
    };

    initialize();
    loadSavedAvatar();
  }, [loadSavedAvatar]);

  function getIconByName(name) {
    switch (name) {
      case "Home":
        return <BiHomeAlt style={{ marginRight: "6px" }} />;
      case "Rastreamento":
        return <CgTrack style={{ marginRight: "6px" }} />;
      case "Grupos":
        return <LuGroup style={{ marginRight: "6px" }} />;
      case "Controle":
        return <BsTruck style={{ marginRight: "6px" }} />;
      case "Atendimento":
        return <BsHeadset style={{ marginRight: "6px" }} />;
      case "Relatórios":
        return <TbReportAnalytics style={{ marginRight: "6px" }} />;
      case "Cadastro":
        return <MdOutlineControlPointDuplicate style={{ marginRight: "6px" }} />;
      case "Manutenção":
        return <BiStopCircle style={{ marginRight: "6px" }} />;
      case "Sistema":
        return <PiDesktop style={{ marginRight: "6px" }} />;
      default:
        return <div></div>;
    }
  }

  const toggleSubmenu = (itemId) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const handleItemClick = (itemId) => {
    console.log("Sidebar: Item clicked:", itemId);
    setActiveItem(itemId);
  };

  const handleItemClickSubMenu = (itemId) => {
    console.log("Sidebar: Item clicked:", itemId);
    setActiveItemSubMenu(itemId);
  };

  return (
    <>
      <div className={`movyx-sidebar ${isCollapsed ? "collapsed" : ""}`}>
        {/* Header */}
        <div className="sidebar-header">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 5,
              justifyContent: "end",
              marginBottom: 5,
            }}
          >
            {!isCollapsed && (
              <>
                <span className="title-minimize">Minimizar</span>
              </>
            )}
            <button
              onClick={() => setIsCollapsed(!isCollapsed)}
              style={{
                paddingLeft: "0.25rem",
                paddingRight: "0.25rem",
                paddingBottom: "0.1rem",
                textAlign: "center",
                border: "none",
                background: "none",
                color: "var(--text-secondary)",
                cursor: "pointer",
                position: "relative",
                backgroundColor: "#293333",
                borderRadius: 40,
              }}
            >
              {!isCollapsed ? (
                <MdOutlineKeyboardBackspace color="#fff" />
              ) : (
                <MdOutlineKeyboardBackspace
                  color="#fff"
                  style={{ transform: "rotate(180deg)" }}
                />
              )}
              <span className="bar"></span>
            </button>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
            }}
          >
            {!isCollapsed ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                  width: "100%",
                }}
                onClick={() => {}}
              >
                <img className="logo sidebar-logo-img" src={movyx} alt="movyx-logo" />
                {currentAvatarPreview ? (
                  <img
                    src={currentAvatarPreview}
                    alt="Avatar"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      cursor: "pointer",
                      border: "2px solid var(--theme-primary)",
                    }}
                    onClick={() => setShowProfile((prev) => !prev)}
                  />
                ) : (
                  <IoPersonCircleOutline
                    style={{
                      fontSize: "40px",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowProfile((prev) => !prev)}
                  />
                )}
                <p className="sidebar-company">
                  {userSession?.userLogName || "Usuário"}
                </p>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                }}
                onClick={() => {}}
              >
                <img
                  className="logo-collapsed"
                  width={"100%"}
                  src={mlogo}
                  alt="m-logo"
                />
                {currentAvatarPreview ? (
                  <img
                    src={currentAvatarPreview}
                    alt="Avatar"
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      cursor: "pointer",
                      border: "2px solid var(--theme-primary)",
                    }}
                    onClick={() => setShowProfile((prev) => !prev)}
                  />
                ) : (
                  <IoPersonCircleOutline
                    style={{
                      fontSize: "30px",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowProfile((prev) => !prev)}
                  />
                )}
              </div>
            )}
          </div>
        </div>

        {/* Navigation */}
        <nav className="sidebar-menu">
          {/* Home Link */}
          <div>
            <Link
              to="home"
              className={`sidebar-item ${
                activeItem === "home" ? "active" : ""
              }`}
            >
              <AiOutlineHome
                className="sidebar-item-icon"
                style={{ marginRight: "6px" }}
              />
              {!isCollapsed && <span className="sidebar-item-text">Home</span>}
            </Link>
          </div>

          {/* Dynamic Menu Items */}
          {menuLayout.map((menu, index) => (
            <div key={menu.menuId || index}>
              {menu.children?.length > 0 ? (
                // Menu with submenu
                <>
                  <button
                    onClick={() => {
                      handleItemClick(menu.menuId);
                      toggleSubmenu(menu.menuId);
                    }}
                    className={`sidebar-item ${
                      activeItem === menu.menuId ? "active" : ""
                    } ${expandedItems[menu.menuId] ? "expanded" : ""}`}
                  >
                    {getIconByName(menu.name)}
                    {!isCollapsed && (
                      <>
                        <span className="sidebar-item-text">
                          {t(`${menu.name}`)}
                        </span>
                        <FaChevronRight className="sidebar-item-arrow" />
                      </>
                    )}
                  </button>

                  {/* Submenu */}
                  {expandedItems[menu.menuId] && !isCollapsed && (
                    <div className="sidebar-submenu">
                      {menu.children.map((child, childIndex) => (
                        <Link
                          to={child.route ? child.route : "workinginprogress"}
                          key={childIndex}
                          className={`sidebar-item-link ${
                            activeItemSubMenu === child.menuId ? "active" : ""
                          }`}
                          style={{ paddingLeft: "1rem" }}
                          onClick={() => {
                            console.log("Sidebar: Child clicked:", child.route);
                            handleItemClickSubMenu(child.menuId);
                          }}
                        >
                          <span className="sidebar-item-text">
                            {child.name}
                          </span>
                        </Link>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                // Menu without submenu
                <Link
                  to={menu.route ? menu.route : "workinginprogress"}
                  className={`sidebar-item ${
                    activeItem === menu.menuId ? "active" : ""
                  }`}
                  onClick={() => {
                    console.log("Sidebar: Menu clicked:", menu.route);
                    handleItemClick(menu.menuId);
                  }}
                >
                  {getIconByName(menu.name)}
                  {!isCollapsed && (
                    <span className="sidebar-item-text">{menu.name}</span>
                  )}
                </Link>
              )}
            </div>
          ))}
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">
          <div style={{ display: "flex", alignItems: "center" }}>
            <button
              className="sidebar-item"
              style={{
                width: "auto",
                padding: "0.5rem",
                margin: 0,
                background: "none",
                border: "none",
                color: "var(--text-secondary)",
                justifyContent: "center",
              }}
              onClick={() => {
                localStorage.removeItem("token");
                window.location.href = "/";
              }}
            >
              <FaSignOutAlt className="sidebar-item-icon" />
              {!isCollapsed && <span className="sidebar-item-text">Sair</span>}
            </button>
          </div>
        </div>
      </div>
      {showProfile && (
        <div
          style={{
            position: "fixed",
            top: 100,
            left: showProfile && !isCollapsed ? 240 : 60,
            height: "100%",
            zIndex: 99,
            overflowY: "auto",
            transition: "left 0.3s ease",
          }}
        >
          <UserNav />
        </div>
      )}
    </>
  );
};

export default Sidebar;
